import React from 'react';
import { TabProps } from '../types';
import { Icon, Header } from 'semantic-ui-react';
import { DesignSystem } from '../../../styles/designSystem';

const ActivitiesTab: React.FC<TabProps> = ({ data }) => {
  return (
    <div style={{
      padding: '1rem',
      background: DesignSystem.colors.section.gradient,
      minHeight: '30vh'
    }}>
      <div style={{
        background: 'white',
        borderRadius: '10px',
        padding: '1rem',
        boxShadow: '0 8px 15px rgba(0,0,0,0.08)',
        border: '1px solid rgba(255,255,255,0.8)'
      }}>
        <Header as="h2" style={{
          color: '#2c3e50',
          textAlign: 'center',
          marginBottom: '1rem',
          fontWeight: '700',
          fontSize: '1.3rem'
        }}>
          <div style={{
            background: 'linear-gradient(135deg, #27ae60, #229954)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            display: 'inline-block'
          }}>
            <Icon name="briefcase" size="large" />
            Atividades Econômicas
          </div>
        </Header>

        {((data.atividadePrincipal && data.atividadePrincipal.length > 0) ||
             (data.activities && data.activities.filter(a => a.isPrincipal).length > 0)) && (
          <div style={{ marginBottom: '2rem' }}>
            <div style={{
              background: 'linear-gradient(135deg, #3498db, #2980b9)',
              borderRadius: '12px',
              padding: '1.5rem',
              marginBottom: '1.5rem',
              color: 'white',
              boxShadow: '0 12px 25px rgba(52, 152, 219, 0.3)'
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '0.75rem' }}>
                <Icon name="star" size="large" />
                <div>
                  <Header as="h3" style={{ color: 'white', margin: 0, fontSize: '1.3rem' }}>
                    Atividade Principal
                  </Header>
                  <p style={{ color: 'rgba(255,255,255,0.8)', margin: '0.2rem 0 0 0', fontSize: '0.9rem' }}>
                    CNAE principal da empresa
                  </p>
                </div>
              </div>
            </div>

            {(data.atividadePrincipal || []).map((atividade, index) => (
              <div key={`receita-${index}`} style={{
                background: 'linear-gradient(135deg, #f8f9fa, #ffffff)',
                borderRadius: '12px',
                padding: '1rem',
                marginBottom: '0.75rem',
                boxShadow: '0 6px 15px rgba(0,0,0,0.05)',
                border: '1px solid rgba(39, 174, 96, 0.1)',
                borderLeft: '4px solid #27ae60',
                transition: 'transform 0.3s ease, box-shadow 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-3px)';
                e.currentTarget.style.boxShadow = '0 12px 25px rgba(0,0,0,0.1)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 6px 15px rgba(0,0,0,0.05)';
              }}
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                  <div style={{
                    background: 'linear-gradient(135deg, #27ae60, #229954)',
                    borderRadius: '50%',
                    padding: '0.5rem',
                    color: 'white',
                    width: '40px',
                    height: '40px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}>
                    <Icon name="briefcase" size="small" />
                  </div>
                  <div style={{ flex: 1 }}>
                    <div style={{
                      color: '#27ae60',
                      fontSize: '1rem',
                      fontWeight: '700',
                      marginBottom: '0.25rem'
                    }}>
                      {atividade.code}
                    </div>
                    <div style={{
                      color: '#2c3e50',
                      fontSize: '0.9rem',
                      lineHeight: '1.4'
                    }}>
                      {atividade.text}
                    </div>
                  </div>
                </div>
              </div>
            ))}

            {(data.activities?.filter(a => a.isPrincipal) || []).map((atividade, index) => (
              <div key={`client-${index}`} style={{
                background: 'linear-gradient(135deg, #f8f9fa, #ffffff)',
                borderRadius: '12px',
                padding: '1rem',
                marginBottom: '0.75rem',
                boxShadow: '0 6px 15px rgba(0,0,0,0.05)',
                border: '1px solid rgba(39, 174, 96, 0.1)',
                borderLeft: '4px solid #27ae60',
                transition: 'transform 0.3s ease, box-shadow 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-3px)';
                e.currentTarget.style.boxShadow = '0 12px 25px rgba(0,0,0,0.1)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 6px 15px rgba(0,0,0,0.05)';
              }}
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                  <div style={{
                    background: 'linear-gradient(135deg, #27ae60, #229954)',
                    borderRadius: '50%',
                    padding: '0.5rem',
                    color: 'white',
                    width: '40px',
                    height: '40px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}>
                    <Icon name="briefcase" size="small" />
                  </div>
                  <div style={{ flex: 1 }}>
                    <div style={{
                      color: '#27ae60',
                      fontSize: '1rem',
                      fontWeight: '700',
                      marginBottom: '0.25rem'
                    }}>
                      {atividade.code}
                    </div>
                    <div style={{
                      color: '#2c3e50',
                      fontSize: '0.9rem',
                      lineHeight: '1.4'
                    }}>
                      {atividade.description}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}

        {((data.atividadesSecundarias && data.atividadesSecundarias.length > 0) ||
             (data.activities && data.activities.filter(a => !a.isPrincipal).length > 0)) && (
          <div>
            <div style={{
              background: 'linear-gradient(135deg, #95a5a6, #7f8c8d)',
              borderRadius: '12px',
              padding: '1.5rem',
              marginBottom: '1.5rem',
              color: 'white',
              boxShadow: '0 12px 25px rgba(149, 165, 166, 0.3)'
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                <Icon name="list" size="large" />
                <div>
                  <Header as="h3" style={{ color: 'white', margin: 0, fontSize: '1.3rem' }}>
                    Atividades Secundárias
                  </Header>
                  <p style={{ color: 'rgba(255,255,255,0.8)', margin: '0.2rem 0 0 0', fontSize: '0.9rem' }}>
                    {((data.atividadesSecundarias?.length || 0) + (data.activities?.filter(a => !a.isPrincipal).length || 0))} atividade{((data.atividadesSecundarias?.length || 0) + (data.activities?.filter(a => !a.isPrincipal).length || 0)) > 1 ? 's' : ''} secundária{((data.atividadesSecundarias?.length || 0) + (data.activities?.filter(a => !a.isPrincipal).length || 0)) > 1 ? 's' : ''}
                  </p>
                </div>
              </div>
            </div>

            {(data.atividadesSecundarias || []).map((atividade, index) => (
              <div key={`receita-sec-${index}`} style={{
                background: 'linear-gradient(135deg, #f8f9fa, #ffffff)',
                borderRadius: '12px',
                padding: '1rem',
                marginBottom: '0.75rem',
                boxShadow: '0 6px 15px rgba(0,0,0,0.05)',
                border: '1px solid rgba(149, 165, 166, 0.1)',
                borderLeft: '4px solid #95a5a6',
                transition: 'transform 0.3s ease, box-shadow 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-3px)';
                e.currentTarget.style.boxShadow = '0 12px 25px rgba(0,0,0,0.1)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 6px 15px rgba(0,0,0,0.05)';
              }}
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                  <div style={{
                    background: 'linear-gradient(135deg, #95a5a6, #7f8c8d)',
                    borderRadius: '50%',
                    padding: '0.5rem',
                    color: 'white',
                    width: '40px',
                    height: '40px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}>
                    <Icon name="list" size="small" />
                  </div>
                  <div style={{ flex: 1 }}>
                    <div style={{
                      color: '#95a5a6',
                      fontSize: '1rem',
                      fontWeight: '700',
                      marginBottom: '0.25rem'
                    }}>
                      {atividade.code}
                    </div>
                    <div style={{
                      color: '#2c3e50',
                      fontSize: '0.9rem',
                      lineHeight: '1.4'
                    }}>
                      {atividade.text}
                    </div>
                  </div>
                </div>
              </div>
            ))}

            {(data.activities?.filter(a => !a.isPrincipal) || []).map((atividade, index) => (
              <div key={`client-sec-${index}`} style={{
                background: 'linear-gradient(135deg, #f8f9fa, #ffffff)',
                borderRadius: '12px',
                padding: '1rem',
                marginBottom: '0.75rem',
                boxShadow: '0 6px 15px rgba(0,0,0,0.05)',
                border: '1px solid rgba(149, 165, 166, 0.1)',
                borderLeft: '4px solid #95a5a6',
                transition: 'transform 0.3s ease, box-shadow 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-3px)';
                e.currentTarget.style.boxShadow = '0 12px 25px rgba(0,0,0,0.1)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 6px 15px rgba(0,0,0,0.05)';
              }}
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                  <div style={{
                    background: 'linear-gradient(135deg, #95a5a6, #7f8c8d)',
                    borderRadius: '50%',
                    padding: '0.5rem',
                    color: 'white',
                    width: '40px',
                    height: '40px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}>
                    <Icon name="list" size="small" />
                  </div>
                  <div style={{ flex: 1 }}>
                    <div style={{
                      color: '#95a5a6',
                      fontSize: '1rem',
                      fontWeight: '700',
                      marginBottom: '0.25rem'
                    }}>
                      {atividade.code}
                    </div>
                    <div style={{
                      color: '#2c3e50',
                      fontSize: '0.9rem',
                      lineHeight: '1.4'
                    }}>
                      {atividade.description}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}

        {(!data.atividadePrincipal || data.atividadePrincipal.length === 0) &&
         (!data.atividadesSecundarias || data.atividadesSecundarias.length === 0) &&
         (!data.activities || data.activities.length === 0) && (
          <div style={{
            background: 'linear-gradient(135deg, #f8f9fa, #ffffff)',
            borderRadius: '15px',
            padding: '3rem',
            textAlign: 'center',
            boxShadow: '0 8px 20px rgba(0,0,0,0.05)',
            border: '1px solid rgba(155, 89, 182, 0.1)'
          }}>
            <Icon name="briefcase" size="huge" style={{ color: '#bdc3c7' }} />
            <Header as="h3" style={{ color: '#7f8c8d', margin: '1rem 0' }}>
              Nenhuma informação disponível
            </Header>
            <p style={{ color: '#95a5a6', fontSize: '1.1rem' }}>
              Não há informações de atividades disponíveis para este CNPJ.
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ActivitiesTab;
